import { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import { fetchPartnersContent } from "../APIClient/apiClient";

export function usePartnerContent() {
  const { currentLanguage } = useTranslation();
  const [content, setContent] = useState({
    title: "",
    description: "",
    cards: [],
    logos: [],
    metaTitle: "",
  });

  useEffect(() => {
    let isActive = true;

    setContent({
      title: "",
      description: "",
      cards: [],
      logos: [],
      metaTitle: "",
    });

    fetchPartnersContent(currentLanguage).then((data) => {
      if (!isActive) {
        return;
      }
      if (data) {
        setContent({
          title: data.title || "",
          description: data.description || "",
          cards: Array.isArray(data.cards) ? data.cards : [],
          logos: Array.isArray(data.logos) ? data.logos : [],
          metaTitle: data.metaTitle || "",
        });
      }
    });

    return () => {
      isActive = false;
    };
  }, [currentLanguage]);

  return content;
}
